<template>
  <div class="website-page-box">
    <web-menu></web-menu>
    <div class="slogan-card">
      <div class="slogin-and-btn">
        <div class="slogan-item-box">
          <div
            v-for="item in sloganItems"
            :key="item.index"
            class="slogan"
            :class="'slogan-item-' + item.index"
          >
            <div class="slogan-title">{{ item.title }}</div>
            <div class="slogan-title slogan-sub-title">{{ item.subTitle }}</div>
            <p class="slogan-desc">{{ item.desc }}</p>
          </div>
        </div>
        <!-- <div class="slogan-item-word">
          <div class="slogan-item-word-btn to-login-btn" @click="toUse">
            免费试用
          </div>
        </div> -->
      </div>
      <div class="card-box">
        <div
          v-for="item in cardItems"
          :key="item.index"
          class="card-item"
          :class="'card-item' + item.index"
        >
          <img
            class="card-item-img"
            :src="require(`@/assets/website/service/service${item.index}.png`)"
            alt=""
          />
          <div class="card-item-title">{{ item.title }}</div>
          <div class="card-item-desc">{{ item.desc }}</div>
        </div>
      </div>
    </div>
    <div class="home-divier">
      <img src="@/assets/website/divier.png" alt="" />
    </div>
    <div class="home-blur-box1"></div>
    <div class="home-blur-box2"></div>

    <partner></partner>
    <footer-box></footer-box>
  </div>
</template>
<script>
import webMenu from "@/components/web-menu.vue";
import footerBox from "@/components/footer.vue";
import partner from "@/components/partner.vue";

export default {
  name: "HomePage",
  components: {
    webMenu,
    footerBox,
    partner,
  },
  data() {
    return {
      sloganItems: [
        {
          index: 1,
          title: "支持多达10种语言",
          subTitle: "支持中、英、法、德、西、葡、阿拉伯、日、韩、马来等语种",
          desc: "即将支持更多的小语种，助力东南亚、中东、拉美出海掘金",
        },
        {
          index: 2,
          title: "一键克隆数字人分身和声音",
          subTitle: "一键克隆形象和音色，音频&文本驱动，快速生成",
          desc: "支持高清修复、AI字幕、视频幕布、语速&语调控制",
        },
        {
          index: 3,
          title: "自主研发的开源混合架构模型",
          subTitle: "自研开源混合模型架构，自采数据集，持续的模型训练",
          desc: "产品持续更新迭代，越用越智能，越用越便宜，单个视频低至¥3.75",
        },
        {
          index: 4,
          title: "自主研发的开源混合架构模型",
          subTitle: "自研开源混合模型架构，自采数据集，持续的模型训练",
          desc: "产品持续更新迭代，越用越智能，越用越便宜，单个视频低至¥3.75",
        },
      ],
      cardItems: [
        {
          index: 1,
          title: "神码AI数字人视频",
          desc: "自主研发的开源混合架构模型",
        },
        {
          index: 2,
          title: "神码AI数字人视频",
          desc: "支持多语种，助力出海",
        },
        {
          index: 3,
          title: "神码AI数字人视频",
          desc: "一键克隆数字人分身和声音",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
.tool-box {
  padding: 120px;
}
.tool-desc {
  font-size: 25px;
  font-weight: 300;
}
.tool-title {
  font-size: 100px;
}

.slogan-card {
  height: 479px;
  display: flex;
  justify-content: space-between;
  margin: 100px 80px 0px 80px;
}
.hover-box {
  width: 880px;
  height: 320px;
  cursor: pointer;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 10;
}
.slogin-and-btn {
  width: 880px;
  height: 463px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  position: relative;
  overflow: hidden;
}
.slogan-item-box {
  position: relative;
}
.slogan {
  width: 880px;
  height: 313px;
  position: absolute;
}
.slogan-item-1 {
  top: 0;
  left: -880px;
}
.slogan-item-2 {
  top: 0;
  left: 0;
}
.slogan-item-3 {
  top: 0;
  left: 880px;
}
.slogan-item-4 {
  top: 0;
  left: 1760px;
}
.slogan-item-box {
  animation: slogan-to-left 10s linear infinite;
}
@keyframes slogan-to-left {
  0% {
    transform: translate(100%, 0);
  }
  30% {
    transform: translate(100%, 0);
  }
  33.33% {
    transform: translate(0, 0);
  }
  63.33% {
    transform: translate(0, 0);
  }
  66.66% {
    transform: translate(-100%, 0);
  }
  96.66% {
    transform: translate(-100%, 0);
  }
  100% {
    transform: translate(-200%, 0);
  }
}

.slogan-title {
  font-size: 64px;
  font-weight: 300;
}
.slogan-sub-title {
  font-size: 50px;
  margin-bottom: 10px;
}
.slogan-desc {
  font-size: 26px;
  font-weight: 300;
  margin-bottom: 100px;
}
.slogan-item-word {
  display: flex;
}
.slogan-item-word-btn {
  width: 260px;
  height: 70px;
  background-size: contain;
  background-repeat: no-repeat;
  color: #fff;
  text-align: center;
  line-height: 70px;
  font-size: 24px;
  cursor: pointer;
}
.to-login-btn {
  background-image: url("@/assets/website/btnBg.png");
  margin-right: 10px;
}
.to-register-btn {
  background-image: url("@/assets/website/service/btn.png");
  width: 224px;
}
.card-box {
  width: 714px;
  height: 479px;
  position: relative;
}
.card-item {
  position: absolute;
  width: 321px;
  height: 397px;
  box-sizing: border-box;
  border-bottom: 2.5px solid rgba(255, 255, 255, 0.4);
  border-top: 2.5px solid rgba(255, 255, 255, 0.4);
  border-radius: 41.67px;
  backdrop-filter: blur(15px);
  background: linear-gradient(
    135.57deg,
    rgba(255, 255, 255, 0.1) 0%,
    rgba(255, 255, 255, 0.05) 101.403%
  );
  padding: 20px 17px 23px 17px;
  text-align: center;
  cursor: pointer;
}
.card-item-img {
  width: 287.5px;
  height: 280px;
}
.card-item-title {
  font-size: 25px;
  margin-top: 10px;
}
.card-item-desc {
  font-size: 17px;
}
.card-item1 {
  top: 82px;
}
.card-item2 {
  left: 167px;
  z-index: 2;
}
.card-item3 {
  top: 82px;
  right: 0;
}
.card-item1 {
  animation: card1-to-left 10s linear infinite;
}
@keyframes card1-to-left {
  30% {
    transform: translate(0, 0);
    z-index: 1;
  }
  33.33% {
    transform: translate(393px, 0);
    z-index: 1;
  }
  63.33% {
    transform: translate(393px, 0);
    z-index: 1;
  }
  66.66% {
    transform: translate(167px, -82px);
    z-index: 20;
  }
  96.66% {
    transform: translate(167px, -82px);
    z-index: 20;
  }
  100% {
    transform: translate(0, 0);
    z-index: 1;
  }
}
.card-item2 {
  animation: card2-to-left 10s linear infinite;
}
@keyframes card2-to-left {
  30% {
    transform: translate(0, 0);
    z-index: 20;
  }
  33.33% {
    transform: translate(-167px, 82px);
    z-index: 1;
  }
  63.33% {
    transform: translate(-167px, 82px);
    z-index: 1;
  }
  66.66% {
    transform: translate(226px, 82px);
    z-index: 1;
  }
  96.66% {
    transform: translate(226px, 82px);
    z-index: 1;
  }
  100% {
    transform: translate(0, 0);
    z-index: 20;
  }
}
.card-item3 {
  animation: card3-to-left 10s linear infinite;
}
@keyframes card3-to-left {
  30% {
    transform: translate(0, 0);
    z-index: 1;
  }
  33.33% {
    transform: translate(-167px, -82px);
    z-index: 20;
  }
  63.33% {
    transform: translate(-167px, -82px);
    z-index: 20;
  }
  66.66% {
    transform: translate(-393px, 0);
    z-index: 1;
  }
  96.66% {
    transform: translate(-393px, 0);
    z-index: 1;
  }
  100% {
    transform: translate(0, 0);
    z-index: 1;
  }
}

.home-divier {
  overflow: hidden;
  margin: -36px;
  margin-top: -30px;
  position: relative;
  height: 356px;
}
.home-divier img {
  width: 100%;
}
.home-blur-box1 {
  width: 400px;
  height: 500px;
  filter: blur(258.33px);
  background: rgb(173, 26, 175);
  opacity: 0.5;
  position: absolute;
  top: 600px;
  left: -300px;
}
.home-blur-box2 {
  width: 200px;
  height: 300px;
  filter: blur(258.33px);
  background: rgb(173, 26, 175);
  opacity: 0.5;
  position: absolute;
  top: 1800px;
  left: 1200px;
}
</style>
